const isNullOrUndefined = (value : any) => value === undefined || value === null;
export default isNullOrUndefined;
